import { createFileRoute } from '@tanstack/react-router';
import * as React from 'react';
import { useTranslations } from 'use-intl';

import { GhostFlagsClient } from '@/components/admin/ghost-flags-client';
import { PageHeader } from '@/components/dashboard/page-header';

export const Route = createFileRoute('/_admin/admin/ghost')({
  component: GhostFlagsPage,
});

function GhostFlagsPage(): React.ReactElement {
  const t = useTranslations('admin.ghost');
  return (
    <div className="mx-auto flex w-full max-w-7xl flex-col gap-6">
      <PageHeader title={t('pageTitle')} subtitle={t('pageSubtitle')} />
      <GhostFlagsClient />
    </div>
  );
}
